/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SearchSubRuleStateResponse
 */
export interface SearchSubRuleStateResponse {
    /**
     * 
     * @type {string}
     * @memberof SearchSubRuleStateResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchSubRuleStateResponse
     */
    errorMessage?: string | null;
}

export function SearchSubRuleStateResponseFromJSON(json: any): SearchSubRuleStateResponse {
    return SearchSubRuleStateResponseFromJSONTyped(json, false);
}

export function SearchSubRuleStateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchSubRuleStateResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'errorMessage': !exists(json, 'errorMessage') ? undefined : json['errorMessage'],
    };
}

export function SearchSubRuleStateResponseToJSON(value?: SearchSubRuleStateResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'errorMessage': value.errorMessage,
    };
}


